import { useState, useCallback, useEffect } from "react";
import {
  AddUserandRoleAPi,
  EditUserAndRoleApi,
  updateStatusApi,
  viewUserAndRole,
} from "../services/user&roleServices";
import { validateRequired } from "../utils/validators";
import { useNavigate } from "react-router-dom";

export const useFetchUserandrole = (
  companyId,
  currentPage,
  search,
  perPage,
  status
) => {
  const [loading, setLoading] = useState(true);
  const [userAndRole, setUserAndRole] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const fetchUserAndRole = useCallback(async () => {
    setLoading(true);
    try {
      const response = await viewUserAndRole(
        `&company_id=${companyId}&page=${currentPage}&page_count=${perPage}&active_status=${status}&search=${search}`
      );
      setUserAndRole(response.get_access_category);
      setTotalCount(response.page_context.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [companyId, currentPage, search, perPage, status]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchUserAndRole();
    }, 500);
    return () => clearTimeout(timer);
  }, [fetchUserAndRole]);

  return {
    loading,
    userAndRole,
    refresh: fetchUserAndRole,
    totalCount,
  };
};

export const CreateAcessCat = (setSelectedCompanyId) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    access_details: {
      user: {
        view: false,
        add: false,
        edit: false,
        active_deactive: false,
      },
      group: {
        view: false,
        add: false,
        edit: false,
        active_deactive: false,
      },
      channel: {
        view: false,
        add: false,
        edit: false,
        active_deactive: false,
      },
      company: {
        view: false,
        add: false,
        edit: false,
        active_deactive: false,
      },
    },
    access_company: "",
    register: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError((prev) => {
      const updatedErrors = { ...prev };
      if (validateRequired(value)) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const validateStep = () => {
    const errors = {};
    if (!validateRequired(formData.register)) {
      errors.register = "User is required";
    }
    if (!validateRequired(formData.access_company)) {
      errors.access_company = "Select company";
    }

    // Check if at least one permission is selected
    const hasPermissions = Object.values(formData.access_details).some(
      (category) => Object.values(category).some((permission) => permission)
    );

    if (!hasPermissions) {
      errors.access_details = "At least one permission is required";
    }

    return errors;
  };
  const filterTruePermissions = (accessDetails) => {
    const filteredPermissions = {};

    Object.keys(accessDetails).forEach((category) => {
      const permissions = accessDetails[category];
      const selectedPermissions = Object.keys(permissions).filter(
        (permission) => permissions[permission]
      );

      if (selectedPermissions.length > 0) {
        filteredPermissions[category] = selectedPermissions;
      }
    });

    return filteredPermissions;
  };

  const handleSubmit = async () => {
    const errors = validateStep();
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    setLoading(true);
    try {
      const cleanedPermissions = filterTruePermissions(formData.access_details);

      const payload = {
        ...formData,
        access_details: cleanedPermissions,
      };
      await AddUserandRoleAPi(payload);
      setFormData({
        access_details: {
          user: {
            view: false,
            add: false,
            edit: false,
            active_deactive: false,
          },
          group: {
            view: false,
            add: false,
            edit: false,
            active_deactive: false,
          },
          channel: {
            view: false,
            add: false,
            edit: false,
            active_deactive: false,
          },
          company: {
            view: false,
            add: false,
            edit: false,
            active_deactive: false,
          },
        },
        access_company: "",
        register: "",
      });

      setSelectedCompanyId(null);
      navigate("/userandrole", { replace: true });
    } catch (error) {
      setError(error.data || { general: "An error occurred" });
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    setFormData,
    setError,
  };
};

export const useEditusrandRole = (onClose) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    access_details: {
      user: {
        view: false,
        add: false,
        edit: false,
        active_deactive: false,
      },
      group: {
        view: false,
        add: false,
        edit: false,
        active_deactive: false,
      },
      channel: {
        view: false,
        add: false,
        edit: false,
        active_deactive: false,
      },
      company: {
        view: false,
        add: false,
        edit: false,
        active_deactive: false,
      },
    },
    id: "",
    access_company: [],
    register: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError((prev) => {
      const updatedErrors = { ...prev };
      if (validateRequired(value)) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const validateStep = () => {
    const errors = {};
    // if (!validateRequired(formData.register)) {
    //   errors.register = "User is required";
    // }
    // if (!validateRequired(formData.access_company)) {
    //   errors.access_company = "Select company";
    // }

    // Check if at least one permission is selected
    const hasPermissions = Object.values(formData.access_details).some(
      (category) => Object.values(category).some((permission) => permission)
    );

    if (!hasPermissions) {
      errors.access_details = "At least one permission is required";
    }

    return errors;
  };
  const filterTruePermissions = (accessDetails) => {
    const filteredPermissions = {};

    Object.keys(accessDetails).forEach((category) => {
      const permissions = accessDetails[category];
      const selectedPermissions = Object.keys(permissions).filter(
        (permission) => permissions[permission]
      );

      if (selectedPermissions.length > 0) {
        filteredPermissions[category] = selectedPermissions;
      }
    });

    return filteredPermissions;
  };

  const handleSubmit = async () => {
    const errors = validateStep();
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    setLoading(true);
    try {
      const cleanedPermissions = filterTruePermissions(formData.access_details);

      const payload = {
        ...formData,
        access_details: cleanedPermissions,
      };
      await EditUserAndRoleApi(payload);
      onClose(); // Close the popup on success
    } catch (error) {
      setError(error.data || { general: "An error occurred" });
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    setFormData,
    setError,
  };
};

export const useUpdateStatusUrndRl = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateUserndRlStatus = async (ids, statusType) => {
    setLoading(true);
    setError(null);
    const data = {
      access_status: statusType,
      ids: ids,
    };

    try {
      await updateStatusApi(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return { updateUserndRlStatus, loading, error };
};
